<template>
    <table class="memberships-list dt-table"
           :class="{ 'dt-table--selection-enabled' : editMode }">
        <thead>
            <tr>
                <th>{{ l('MANAGE_ACCOUNT_MEMBERSHIPS.HEADING_REFERENCE') }}</th>
                <th>{{ l('MANAGE_ACCOUNT_MEMBERSHIPS.HEADING_MEMBERS') }}</th>
                <th class="dt-table__cell--last memberships-list--actions-col-heading">
                    <slot></slot>
                </th>
            </tr>
        </thead>
        <tbody>
            <MembershipListMembership v-for="membership in memberships"
                                      :key="membership.ID"
                                      :membership="membership"
                                      :selectable="editMode"
                                      @select="$emit('select', membership)"
                                      @edit="$emit('edit', membership)"
                                      @click="$emit('click', membership)" />
        </tbody>
    </table>
</template>

<script>
import MembershipListMembership from '@/epos/vue/components/Memberships/MembershipListMembership';

export default {
    components: { MembershipListMembership },

    props: {
        /**
         * @type {Membership[]}
         */
        memberships: {
            type: Array,
            required: true,
        },

        selectedMemberships: {
            type: Array,
            default: () => [],
        },

        editMode: {
            type: Boolean,
            default: false,
        },
    },

    emits: [
        'select',
        'edit',
        'click',
    ],
};
</script>

<style lang="less">
// This is a hack to fix the buttons in the header on the membership list.
// The right column header doesn't have enough space for all the buttons, and the middle column has excess space.
// Use an absolutely positioned element to bring the buttons on top of the cells so they can use
// all the available space.
.memberships-list--actions-col-heading {
    position: relative;
    height: 55px;
    width: 130px; // Be wide enough for the Select / Selected corner text.

    > span {
        display: block;
        position: absolute;
        top: 6px;
        right: 6px;
        white-space: nowrap;
    }
}
</style>
